/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e674ae8e4bcaa3ce828d44ac8144dec4>>
 * @codegenCommand yarn build:icon-glyphs
 */
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _baseNew = _interopRequireDefault(require("@atlaskit/icon/base-new"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * Icon: "MagicWand".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */
const MagicWandIcon = props => /*#__PURE__*/_react.default.createElement(_baseNew.default, Object.assign({
  dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M10 2V0h1.5v2zM7.922 3.482 6.507 2.068l1.061-1.06 1.414 1.414zm7.07-1.414-1.414 1.414-1.06-1.06 1.414-1.415zM8.779 4.162a1.375 1.375 0 0 1 1.944 0l1.116 1.116a1.375 1.375 0 0 1 0 1.944l-8.116 8.116a1.375 1.375 0 0 1-1.944 0L.662 14.222a1.375 1.375 0 0 1 0-1.944zM9.75 5.31 8.31 6.75l.94.94 1.44-1.44zM8.19 8.75l-.94-.94-5.44 5.44.94.94zM16 6h-2V4.5h2zm-2.068 3.493-1.414-1.415 1.06-1.06 1.415 1.414z" clip-rule="evenodd"/>`
  // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
}, props));
MagicWandIcon.displayName = 'MagicWandIcon';
var _default = exports.default = MagicWandIcon;